const TrustMetric = () => {
  return (
    <h3 className="text-lg font-bold text-[#1C4532]">
      Zaufało nam 1500+ Właścicieli Firm
    </h3>
  );
};

export default TrustMetric;